/**
 * Duration estimate shown on export menus and the progress toast. The constants
 * live here so every table export reads the same rule.
 */
const BASE_SECONDS = 1;
const ROWS_PER_SECOND = 100;
const FEW_SECONDS_LIMIT = 5;
const ROUND_TO_SECONDS = 5;
const LARGE_ROSTER_SECONDS = 45;

export function estimateExportSeconds(rowCount: number): number {
  return BASE_SECONDS + rowCount / ROWS_PER_SECOND;
}

export function formatExportEstimate(seconds: number): string {
  if (seconds < FEW_SECONDS_LIMIT) return 'a few seconds';
  const rounded = Math.round(seconds / ROUND_TO_SECONDS) * ROUND_TO_SECONDS;
  const text = `about ${rounded} seconds`;
  return seconds > LARGE_ROSTER_SECONDS ? `${text}, large roster` : text;
}

/** Elapsed-time counter: "42s" under a minute, "1:05" after. */
export function formatElapsed(seconds: number): string {
  const whole = Math.floor(seconds);
  if (whole < 60) return `${whole}s`;
  const minutes = Math.floor(whole / 60);
  const rest = whole % 60;
  return `${minutes}:${rest.toString().padStart(2, '0')}`;
}
